/**
 * Returns an array of SVG path commands for the ScaleUI Caution icon, allowing it to be rendered in Highcharts.
 * To use, pass this function to Highcharts.SVGRenderer.prototype.symbols.[iconName], and use [iconName] as the marker symbol in the chart/series options.
 * @param x - The x-coordinate of the top-left corner of the icon.
 * @param y - The y-coordinate of the top-left corner of the icon.
 * @param w - The width of the icon.
 * @param h - The height of the icon.
 * @returns An array of SVG path commands.
 */
export const highchartsCautionRenderer = function (x: number, y: number, w: number, h: number) {
  return [
    // Path 1 (circle)
    'M',
    x + (8.0498 / 16) * w,
    y + (9.75977 / 16) * h,
    'C',
    x + (8.40472 / 16) * w,
    y + (9.75977 / 16) * h,
    x + (8.69315 / 16) * w,
    y + (10.0483 / 16) * h,
    x + (8.69336 / 16) * w,
    y + (10.4043 / 16) * h,
    'C',
    x + (8.69336 / 16) * w,
    y + (10.7605 / 16) * h,
    x + (8.40484 / 16) * w,
    y + (11.0498 / 16) * h,
    x + (8.0498 / 16) * w,
    y + (11.0498 / 16) * h,
    'C',
    x + (7.69496 / 16) * w,
    y + (11.0496 / 16) * h,
    x + (7.40723 / 16) * w,
    y + (10.7603 / 16) * h,
    x + (7.40723 / 16) * w,
    y + (10.4043 / 16) * h,
    'C',
    x + (7.40744 / 16) * w,
    y + (10.0485 / 16) * h,
    x + (7.6951 / 16) * w,
    y + (9.76 / 16) * h,
    x + (8.0498 / 16) * w,
    y + (9.75977 / 16) * h,
    'Z',
    // Path 2 (rectangle)
    'M',
    x + (8.7998 / 16) * w,
    y + (9 / 16) * h,
    'H',
    x + (7.2998 / 16) * w,
    'V',
    y + (5 / 16) * h,
    'H',
    x + (8.7998 / 16) * w,
    'V',
    y + (9 / 16) * h,
    'Z',
    // Path 3 (rounded rect outline)
    'M',
    x + (12.2041 / 16) * w,
    y + (2.01074 / 16) * h,
    'C',
    x + (13.2128 / 16) * w,
    y + (2.113 / 16) * h,
    x + (14 / 16) * w,
    y + (2.96435 / 16) * h,
    x + (14 / 16) * w,
    y + (4 / 16) * h,
    'V',
    y + (12 / 16) * h,
    'L',
    x + (13.9893 / 16) * w,
    y + (12.2041 / 16) * h,
    'C',
    x + (13.8938 / 16) * w,
    y + (13.1456 / 16) * h,
    x + (13.1456 / 16) * w,
    y + (13.8938 / 16) * h,
    x + (12.2041 / 16) * w,
    y + (13.9893 / 16) * h,
    'L',
    x + (12 / 16) * w,
    y + (14 / 16) * h,
    'H',
    x + (4 / 16) * w,
    'C',
    x + (2.96449 / 16) * w,
    y + (13.9998 / 16) * h,
    x + (2.11299 / 16) * w,
    y + (13.2127 / 16) * h,
    x + (2.01074 / 16) * w,
    y + (12.2041 / 16) * h,
    'L',
    x + (2 / 16) * w,
    y + (12 / 16) * h,
    'V',
    y + (4 / 16) * h,
    'C',
    x + (2 / 16) * w,
    y + (2.89553 / 16) * h,
    x + (2.89557 / 16) * w,
    y + (2.00016 / 16) * h,
    x + (4 / 16) * w,
    y + (2 / 16) * h,
    'H',
    x + (12 / 16) * w,
    'L',
    x + (12.2041 / 16) * w,
    y + (2.01074 / 16) * h,
    'Z',
    'M',
    x + (4 / 16) * w,
    y + (3.5 / 16) * h,
    'C',
    x + (3.724 / 16) * w,
    y + (3.50016 / 16) * h,
    x + (3.5 / 16) * w,
    y + (3.72396 / 16) * h,
    x + (3.5 / 16) * w,
    y + (4 / 16) * h,
    'V',
    y + (12 / 16) * h,
    'C',
    x + (3.5 / 16) * w,
    y + (12.276 / 16) * h,
    x + (3.724 / 16) * w,
    y + (12.4998 / 16) * h,
    x + (4 / 16) * w,
    y + (12.5 / 16) * h,
    'H',
    x + (12 / 16) * w,
    'C',
    x + (12.2761 / 16) * w,
    y + (12.5 / 16) * h,
    x + (12.5 / 16) * w,
    y + (12.2761 / 16) * h,
    x + (12.5 / 16) * w,
    y + (12 / 16) * h,
    'V',
    y + (4 / 16) * h,
    'C',
    x + (12.5 / 16) * w,
    y + (3.72386 / 16) * h,
    x + (12.2761 / 16) * w,
    y + (3.5 / 16) * h,
    x + (12 / 16) * w,
    y + (3.5 / 16) * h,
    'H',
    x + (4 / 16) * w,
    'Z',
  ];
};

/**
 * Returns an array of SVG path commands for the ScaleUI Caution icon, allowing it to be rendered in Highcharts. The svg is offset by half its size along the y axis for the icon not to overlap with the axis line.
 * To use, pass this function to Highcharts.SVGRenderer.prototype.symbols.[iconName], and use [iconName] as the marker symbol in the chart/series options.
 * @param x - The x-coordinate of the top-left corner of the icon.
 * @param y - The y-coordinate of the top-left corner of the icon.
 * @param w - The width of the icon.
 * @param h - The height of the icon.
 * @returns An array of SVG path commands.
 */
export const highchartsCautionRendererXAxisOffset = function (
  x: number,
  y: number,
  w: number,
  h: number
) {
  return highchartsCautionRenderer(x, y + h * 0.75, w, h);
};
